<template>
  <div class="com-page" v-wechat-title="this.title">
    <div style="width: 100%;box-sizing: border-box;overflow-y: scroll;overflow-x: hidden;-webkit-overflow-scrolling: auto;font-size: .24rem;"  ref="wrapper" :style="{ height: (wrapperHeight) + 'px' }">
    <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" bottomPullText="" bottomDropText="正在加载..." ref="loadmore" :auto-fill="false">
    <div class="header_download flex">
      <div class="flex">
        <img class="logo2" src="../../assets/logo2.png" alt="" />
        <img class="voiceLogo2" src="../../assets/voiceLogo2.png" alt="" />
      </div>
      <img src="../../assets/btn_download2.png" alt="下载" class="download" @click="download"/>
    </div>
    <div class="comPage-compere">
      <div class="topCon">
        <img class="avatar" :src="compereMsg.avatar" alt="" />
        <div class="flex follow">
          <div class="follow_text"  @click="toDownloadpage()">关注</div>
          <div class="private"  @click="toDownloadpage()">私信</div>
        </div>
        <div class="comMessage">
          <div class="flex">
            <p class="comname">{{ compereMsg.nickname }}</p>
            <img class="sex" v-show="compereMsg.gender == 'f'" src="../../assets/woman.png" alt="" />
            <img class="sex" v-show="compereMsg.gender == 'm'" src="../../assets/man.png" alt="" />
          </div>
          <div class="number">听见号{{ compereMsg.number }}</div>
           <div class="labels flex">
            <div>{{ compereMsg.city || '未知星球' }}</div>
            <div>{{ compereMsg.constellation }}</div>
            <div v-if="compereMsg.host_rank">{{ compereMsg.host_rank }}</div>
          </div>
          <div class="introduction">{{ compereMsg.slogan }}</div>
          <div class="attFens">
            <span class="attentionNum">{{ compereMsg.stars | peopleNumber }}</span>
            <span v-if="compereMsg.stars !== undefined && compereMsg.stars.length >=5 " style="font-size: 0.25rem; color: rgba(102, 102, 102, 1)">w</span>
            <font class="att-font">关注</font>
            <i></i>
            <span class="fensNum">{{ compereMsg.fans | peopleNumber }}</span>
            <span v-if="compereMsg.fans !== undefined && compereMsg.fans.length >= 5" style="font-size: 0.25rem; color: rgba(102, 102, 102, 1)">w</span>
            <font class="att-font">粉丝</font>
             <i></i>
            <span class="fensNum">{{ compereMsg.visit | peopleNumber }}</span>
            <span v-if="compereMsg.visit !== undefined && compereMsg.visit.length >= 5" style="font-size: 0.25rem; color: rgba(102, 102, 102, 1)">w</span>
            <font class="att-font">访客</font>
          </div>
          <div class="addMsg">
            <div class="channelName flex" v-if="compereMsg.shop_url" @click="shopUrl(compereMsg.shop_url)">
              <div class="title flex">
                <img style="width:.3rem;height:.28rem;margin-right:.1rem" src="../../assets/house.png" alt="">
                <div>商品橱窗</div>
              </div>
              <div class="channelCon flex">
                <span>{{compereMsg.shop_product_count}}件商品</span>
                <img src="../../assets/right1.png" alt="" />
              </div>
            </div>
            <div class="channelName flex">
              <div class="title flex">
                <img style="width:.3rem;height:.28rem;margin-right:.1rem" src="../../assets/user_heart.png" alt="">
                <div>粉丝团</div>
              </div>
              <div class="channelCon flex">
                <span>{{compereMsg.fans_club_count}}团员</span>
                <img src="../../assets/right1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="table-bar">
        <div class="table-bar-item" @click="checkTab(item.order)" :class="currentTab=== item.order  ? 'table-bar-item-active': 'table-bar-item-default'"  v-for="(item, index) in tableBar" :key="index">{{item.name}} <b></b> </div>
    </div>
    </div>
    <div class="table_bar_item" v-show="currentTab=='1'">
      <program v-if="programList.length > 0" :commenProgram="programList"></program>
      <div v-else class="noList">暂无节目</div>
    </div>
    <div class="table_bar_item" v-show="currentTab=='2'">
      <works v-if="workList.length > 0" :commenProgram="workList"></works>
      <div v-else class="noList">暂无作品</div>
    </div>

    </mt-loadmore>
    </div>


    <myfooter></myfooter>
    <toast :msg="msg"></toast>
  </div>
</template>

<script>
import myfooter from "../commen/myfooter";
import cbct from "../../../static/js/base.js";
import share from "../../../static/js/share.js";
import toast from "../commen/toast.vue";
import router from "../../router";
import qs from "qs";
import works from "../commen/works";//作品
import program from "../commen/program";//节目

export default {
  name: "share",
  props: {},
  data() {
    return {
      compereMsg: [],
      recommen1: [],
      recommen2: [],
      sex: [],
      iscur: 0,
      msg: "",
      number: "",
      stars: "",
      fans: "",
      type: "",
      title: "",
      isPage: "的主页",
      appName: "-听见广播",
      radioName: "",
      channelName: "",
      pName: [],
      recommendRecorded: [],
      currentTab: '1',
      tableBar: [
        {name: '节目', order : '1'},
        {name: '作品', order : '2'}
      ],
      programList:[],
      workList:[],
      page:1,
      wrapperHeight:0,
      allLoaded:true,//是否加载完毕
    };
  },
  filters: {
    peopleNumber: function (n1) {
        n1 = n1
         if (n1!="") {
            let strNum="";
         if (n1 >= 0 && n1 < 10000) {
           strNum=n1
         }else{
           strNum=(parseFloat(n1/10000).toFixed(1))
         }
         return strNum     
         }
    },
  },
  created() {
    let self = this;
    if (self.$route.query.number) {
      self.number = self.$route.query.number;
    }
    if (self.$route.query.hoster_id) {
      self.number = self.$route.query.hoster_id;
    }
    self.type = self.$route.query.type;
    // self.bus.$emit('loading',true);
    self.$api.post(cbct.baseurl + "share/home-page",qs.stringify({ number: this.number, type: this.type }))
      .then(function (res) {
        // self.bus.$emit('loading',false);
        if (res.c == cbct.code.successCode) {
          res.d.avatar = cbct.imgUrlAvatar()+res.d.avatar
          self.compereMsg = res.d;
            // if (res.d.programme_recommend.length > 0) {
            //   self.recommendRecorded = res.d.programme_recommend;
            // } else if (res.d.programme_recommend.length == 0) {
            //   self.recommendRecorded=['none'];
            // }
            console.log(self.recommendRecorded)
          if (res.d.is_del == "1") {
            self.$router.push({
              path: "delPage",
            });
            return;
          }
          share.share(self,window.location.href,res.d.nickname + "-"+res.d.city+'电台主持人',res.d.slogan,res.d.avatar,res.d.nickname + "-"+res.d.city+'电台主持人');
          share.QQshare(window.location.href,res.d.nickname + "-"+res.d.city+'电台主持人',res.d.slogan,res.d.avatar);
          
          if (self.$route.query.title) {
            self.title = self.$route.query.title + self.appName;
          } else {
            self.title = res.d.nickname + self.isPage + self.appName;
          }
          self.radioName = res.d.radio_name;
          self.channelName = res.d.channel_name;
          if (res.d.programme.length != 0) {
            self.pName = res.d.programme;
          }
        } else {
          self.bus.$emit("toast", { show: true, title: res.m });
        }
      })
      .catch((res) => {
        //  console.log(res);
      });
      self.getPlay()
  },
  mounted:function(){
    // console.log(this.$refs.aaaa)
    let _this = this
    this.$nextTick(()=>{
      console.log(_this.$refs.wrapper)
      _this.wrapperHeight = document.documentElement.clientHeight;
    })
  },
  methods: {
    shopUrl(url){
      window.location.href=url
    },
    checkTab(order) {
      this.currentTab = order;
      order == '1' ? (this.getPlay(),this.workList = [],this.page=1,this.allLoaded=true) : (this.getVideoList(),this.allLoaded=false)
    },
    loadBottom:function(){//上拉加载
      if (!this.allLoaded) {
        this.page+=1;
        let self =this;
        self.getVideoList();
        this.$refs.loadmore.onBottomLoaded();
      }else{
        this.allLoaded=true;
      }
    },
    //获取作品
    getVideoList(){
      let _this = this
      _this.$api.post(cbct.baseurl+"share/video-list",qs.stringify({
        // number:'5151080',
        number:_this.number,
        type:1,
        page:_this.page,
        pageSize:10
      })).then(function(res){
        console.log(res)
        _this.workList = _this.workList.concat(...res.d)
        _this.workList.length == '0' && res.d.length == '0' ? _this.allLoaded = true : _this.allLoaded = false
      })
    },
    //获取节目
    getPlay(){
      let _this = this
      _this.$api.post(cbct.baseurl+"share/host-programmer-list",qs.stringify({
        number:_this.number
      })).then(function(res){
        console.log(res)
        res.d.list.map(item=>{
          // item.image = cbct.imgUrl() + item.image
          item.play_live_time = _this.handleTime(item.play_live_time)
        })
        _this.programList = res.d.list
      })
    },
    toDownloadpage() {
      //点击下载
      this.$router.push({path:"downloadApp?isFrom=programRecorded"});
    },
    nextChannel: function (id) {
      this.$router.push({
        path: "ratePage?channel_id=" + id,
      });
    },
    nextP: function (number, title) {
      this.$router.push({path:"programStop?isendShare=0&programme_id=" +number +"&type=1&title=" +title,});
    },
    download() {
      //点击下载
      this.$router.push({
        path:
          "downloadApp?isFrom=programRecorded&is_live=" +
          this.isLive +
          "&number=" +
          this.number,
      });
    },
                /**
     * @description 将秒处理成时分秒的形式
     * @param {time} 当前秒数
     */
    handleTime(time) {
      let h, m, s,timeDom;
      h = Math.floor(time  / 60 / 60);
      m = Math.floor(time  / 60 % 60);
      s = Math.floor(time  % 60);
      h = h < 10 ? ("0" + h) : h;
      m = m < 10 ? ("0" + m) : m;
      s = s < 10 ? ("0" + s) : s;
      timeDom = h + ":" + m + ":" + s
      return timeDom
      // const h = Math.floor( time/3600 ) < 10 ?  `0${Math.floor( time/3600 )  }`: Math.floor( time/3600 ) < 10 
      // const m = Math.floor( time/60 % 60 ) < 10 ? `0${Math.floor( time/60 % 60 )}`: Math.floor( time/60 % 60 )
      // const s = Math.floor( time % 60 ) < 10 ? `0${Math.floor( time % 60 )}`: Math.floor( time % 60 )
      // return `${h}:${m}:${s}`
    },
  },

  components: {
    myfooter,
    toast,
    program,
    works
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header_download {
  width: 100%;
  height: 0.88rem;
  background: #e8e8e8;
  justify-content: space-between;
}
.header_download .logo2 {
  width: 0.72rem;
  height: 0.74rem;
  /* margin: 0.12rem 0 0.1rem 0.22rem; */
  margin: 0 0.28rem 0 0.48rem;
}
.header_download .voiceLogo2 {
  height: 0.4rem;
  width: auto;
}
.header_download .download {
  width: 1.42rem;
  height: 0.6rem;
  margin: 0.2rem 0.36rem 0.2rem 0;
}
li {
  list-style: none;
}
.downloadApp {
  box-sizing: border-box;
}
.clear {
  clear: both;
}
.downloadApp p {
  height: 0.76rem;
  width: 4.4rem;
  margin: 0.35rem auto 0.34rem;
}
.downloadApp p img {
  width: 100%;
  height: 100%;
}
.addMsg {
  box-sizing: border-box;
  padding: 0.28rem 0 0;
  /* border: solid 1px;  */
  font-size: 0.24rem;
  text-align: left;
}
.addMsg div {
  /* margin-bottom: 0.18rem; */
  /* color: rgba(49, 49, 49, 1); */
  font-size: 0.28rem;
  justify-content: space-between;
  /* overflow: hidden; */
}
.addMsg div font {
  width: 0.84rem;
}
.addMsg div img {
  width: 0.22rem;
  margin-left: 0.08rem;
  /* float: right; */
}
.channelName {
  display: flex;
  padding: 0.18rem 0 0.22rem;
  border-top: solid 0.01rem rgba(0, 0, 0, 0.1);
  /* overflow: hidden; */
}

.channelName .title {
  font-size: 0.28rem;
  color: rgba(0, 0, 0, 0.8);
  line-height: 0.4rem;
  font-weight: 800;
}
.boldLine {
  height: 0.2rem;
  background: rgba(248, 248, 248, 1);
}
.addMsg .pName {
  display: flex;
  /* overflow: hidden; */
  /* align-items: center; */
}
.addMsg .pName .p {
  width: 87%;
}
.pnameCon {
  /* border: solid 1px; */
  width: 100%;
}
.pnameCon img {
  width: 0.22rem;
  float: right;
}

.com-page {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background: #f7f8f9;
}
.comPage-compere {
  width: 100%;
  overflow: hidden;
  background-image: url("../../assets/bg2.png");
  background-size: 100% 3.04rem;
  background-repeat: no-repeat;
}
.topCon {
  /* width: 100%; */
  box-sizing: border-box;
  margin: 1.42rem 0.3rem 0;
  padding: 0.02rem;
  position: relative;
  background: white;
  border-radius: 0.16rem;
}
.comMessage {
  width: 100%;
  box-sizing: border-box;
  margin-top: 1.48rem;
  padding: 0rem 0.4rem 0;
  /* display: flex; */
  align-items: center;
  /* border-bottom: solid 0.01rem rgba(221,221,221,1) */
}
.comImg {
  width: 1.45rem;
  height: 1.44rem;
  margin-top: 0.14rem;
  vertical-align: middle;
}
.avatar {
  width: 1.72rem;
  height: 1.72rem;
  position: absolute;
  top: -0.6rem;
  left: 0.4rem;
  border-radius: 100%;
  border: 2px solid #ffffff;
}
.follow {
  position: absolute;
  top: 0.24rem;
  right: 0.4rem;
}
.follow .follow_text {
  width: 1.8rem;
  height: 0.6rem;
  line-height: 0.65rem;
  text-align: center;
  background: #ff3c39;
  color: white;
  font-size: 0.24rem;
  border-radius: 0.36rem;
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.follow .private {
  width: 1.1rem;
  height: 0.6rem;
  line-height: 0.6rem;
  text-align: center;
  margin-left: 0.12rem;
  background: #f8f8f8;
  color: #000000;
  font-size: 0.24rem;
  border-radius: 18px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.comImg > img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}
.comMsg {
  width: 2.92rem;
  margin-left: 0.36rem;
  text-align: left;
  /* line-height: 0.25rem; */
}
.comname {
  /* height: 0.35rem; */
  color: #000000;
  letter-spacing: 20;
  font-size: 0.4rem;
  margin-right: 0.2rem;
  font-weight: 600;
}
.sex {
  width: 0.28rem;
  height: 0.28rem;
}
.number {
  font-size: 0.24rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  text-align: left;
  padding: 0.16rem 0 0.32rem;
}
.labels > div {
  padding: .04rem .08rem;
  line-height: 0.4rem;
  text-align: center;
  margin-right: 0.16rem;
  font-size: 0.22rem;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 0.28rem;
  color: rgba(0, 0, 0, 0.5);
}
.introduction {
  line-height: 1.4;
  padding: 0.24rem 0 0.32rem;
  text-align: left;
  font-size: 0.28rem;
  color: rgba(0, 0, 0, 0.5);
}
.channelCon {
  color: rgba(0, 0, 0, 0.5);
}
.table-bar {
  display: flex;
  margin: .4rem 0 .16rem .54rem;
  font-size: .3rem;
  font-weight: 600;
  color: rgba(0, 0, 0, .5);
}
  .table-bar-item:first-child {
    margin-right: 0.46rem;
    height: 0.44rem;
    padding-bottom: .14rem;
  }
  .table-bar-item-active {
    position: relative;
    color: rgba(0, 0, 0, 1);
    
  }
  .table-bar-item-active b {
      position: absolute;
      bottom: 0.04rem;
      left: 0.04rem;
      width: 0.46rem;
      height: 0.08rem;
      background:red;
      border-radius: .04rem;

    }


.sexAdd {
  margin: 0.24rem 0 0.25rem;
  display: flex;
  align-items: center;
}
.sexAdd img {
  width: 0.28rem;
  height: 0.28rem;
}
.sexAdd .add {
  margin-left: 0.12rem;
  border: 0;
  border: solid 1px rgba(252, 204, 100, 1);
  border-radius: 0.05rem;
  text-align: center;
  font-size: 0.2rem;
  font-weight: 500;
  color: rgba(69, 27, 41, 1);
  background: rgba(252, 204, 100, 1);
  height: 0.3rem;
  line-height: 0.3rem;
  padding: 0 0.12rem;
}
.sexAdd .add1 {
  border: solid 1px #333333;
  color: #333;
  background: white;
}
.introce {
  margin-top: 0.25rem;
  height: 0.23rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.24rem;
  font-weight: 400;
  color: #333;
}
.attFens {
  /* margin-top: 0.23rem; */
  height: 0.2rem;
  line-height: 0.2rem;
  font-weight: 400;
  display: flex;
  align-items: center;
}
.attentionNum,
.fensNum {
  font-size: 0.36rem;
  color: rgba(0, 0, 0, 1);
  font-weight:500
}

.att-font,
.fens-font {
  font-size: 0.21rem;
  color: rgba(153, 153, 153, 1);
}
.att-font {
  margin: 0 0.17rem 0 0.12rem;
}
.fensNum {
  margin: 0 0 0 0.14rem;
}
.programOrlife {
  margin: 0.58rem auto 0.56rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.programOrlife li {
  width: 3.51rem;
  text-align: center;
  font-size: 0.3rem;
  font-weight: 500;
  padding-bottom: 0.16rem;
  border-bottom: solid 0.04rem rgba(153, 153, 153, 1);
  color: rgba(153, 153, 153, 1);
}
.noList{
    height: 6.16rem;
    line-height: 6rem;
    color: rgba(153, 153, 153, 1);
    font-size: .34rem;
}

li.active {
  color: rgba(253, 16, 49, 1);
  border-bottom: solid 0.04rem rgba(253, 16, 49, 1);
}
.flex {
  display: flex;
  align-items: center;
}
.table_bar_item{
  margin: 0 .3rem;
  background: white;
}
</style>
